import { AnyAction } from 'redux';

interface LinkModel {
    href: string;
    text: string;
}

export interface PagesState {
    myPage: LinkModel;
}

const defaultState: PagesState = {
    myPage: {
        href: '',
        text: '',
    },
};

export const pages = (
    state = defaultState,
    action: AnyAction
): PagesState => {
    const { type, payload } = action;
    switch (type) {
        default:
            return state;
    }
};
